import styled from 'styled-components';

import { FilledStarIcon } from '@assets/icons/FilledStar';
import { IconLink } from '@assets/icons/IconLink';
import { useClientEnvironment } from '@hooks/clientEnvironment';

export const FaqMessage = () => {
  const { data: clientEnvironment } = useClientEnvironment();
  const helpCenterUrl = clientEnvironment?.support_help_center_url;

  return (
    <StyledContainer>
      <FilledStarIcon />
      <StyledParagraph>
        <span>
          See booking FAQ and a full rundown of our statuses and booking process
          by visiting our
        </span>{' '}
        <StyledLink href={helpCenterUrl} target='_blank'>
          <span>Help Center</span>
          <IconLink />
        </StyledLink>
      </StyledParagraph>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  padding: 11px 15px;
  display: flex;
  align-items: start;
  gap: 8px;
  border: 1px solid ${({ theme }) => theme.palette.stroke[1]};
  border-radius: 8px;

  @media (max-width: 960px) {
    padding: 11px;
  }
`;

const StyledParagraph = styled.p`
  margin: 0;
  width: calc(100% - 32px);
`;

const StyledLink = styled.a`
  display: inline-flex;
  gap: 4px;
  align-items: center;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  color: ${({ theme }) => theme.palette.text[0]};

  &:hover {
    color: ${({ theme }) => theme.palette.text[0]};
  }
`;
